import React from 'react';
import RowsLoader from '../RowsLoader.js';
import '@elliemae/ds-basic/Spinner';
import './defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import '../../blockNames.js';

function renderRowsLoader() {
  return /*#__PURE__*/React.createElement(RowsLoader, null);
}

export { renderRowsLoader };
//# sourceMappingURL=renderRowsLoader.js.map
